<app-reset-password-form
  *ngIf="email && token"
  [email]="email"
  [token]="token"
></app-reset-password-form>
